import { IPossibleValue } from '@/types/serverField.type'

export class PossibleValue {
  id?: number
  title: string
  value: unknown
  disabled: boolean

  constructor (data: IPossibleValue) {
    this.title = data?.Title || ''
    this.value = data?.Value
    this.disabled = data?.Disabled || false

    if (data?.Id !== undefined) {
      this.id = data?.Id
    }
  }
}
